module.exports = __webpack_public_path__ + "img/pc_contact.f956e0a.jpg";